<template>
  <div class="page">
    <div class="pagetitle">
      <h1>Планы</h1>
      <nav>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
          <li class="breadcrumb-item active">Планы</li>
        </ol>
      </nav>
    </div>

    <PlanListBlock
        :plans="plans"
        @delete="openDelete"
        @add="openCreate"
        @drag="onDragEnd"
    />

    <p v-if="loading">Loading...</p>

    <BaseModal
        v-if="isCreateOpen"
        title="Добавить план"
        @close="closeCreate"
    >
      <PlanForm
          :initial="initial"
          :accounts="accounts"
          :error-message="messagePlanError"
          @submit="onAdd"
          @cancel="closeCreate"
      />
    </BaseModal>

    <DeleteModal
        title="Подтвердите удаление"
        :isOpen="isOpenDelete"
        @accept="onDelete"
        @close="closeDelete"
    />

  </div>
</template>

<script setup>
import {computed, onMounted, reactive, ref, watch} from 'vue';
import PlanListBlock from "@/features/plans/components/PlanListBlock.vue";
import {usePlan} from "@/features/plans/composables/usePlan";
import BaseModal from "@/components/ui/components/BaseModal.vue";
import PlanForm from "@/features/plans/components/PlanForm.vue";
import {listAccounts} from "@/api/accounts";
import DeleteModal from "@/components/ui/components/DeleteModal.vue";

const {
  plans,
  loadingPlan,

  isSuccessPlan,
  messagePlanSuccess,
  messagePlanError,

  load,
  addPlan,
  updatePlan,
  sortPlans,
  deletePlan
} = usePlan();

const isCreateOpen = ref(false);
const initial = ref({});
const accounts = ref([]);

const page = 1;
const size = 1000;

onMounted(async () => {
  await Promise.all([load(page, size)]);
  const data = await listAccounts(page, size)
  accounts.value = data.content
});

function openCreate() {
  isCreateOpen.value = true;
}
function closeCreate() {
  isCreateOpen.value = false;
  messagePlanError.value = "";
}

async function onAdd(payload) {
  for (var field in payload) {
    payload[field] = payload[field] === '' ? null : payload[field];
  }
  await addPlan(payload);
  if (isSuccessPlan.value) {
    closeCreate();
    await load(page, size);
  }
}

const onDragEnd = async (planCards) => {
  const planSort = planCards.map((plan, index) => ({
    id: plan.id,
    sort: index + 1
  }));

  await sortPlans({plans: planSort});
  await load(page, size);
}

const isOpenDelete = ref(false);
const deleteObj = ref(null);
function openDelete(payload) {
  isOpenDelete.value = true;
  deleteObj.value = payload
}

function closeDelete() {
  isOpenDelete.value = false;
}

async function onDelete() {
  await deletePlan(deleteObj.value.id);
  deleteObj.value = null;
  isOpenDelete.value = false;
  await load(page, size);
}

</script>
